import { connect } from "react-redux";

export default function withRma(Component) {
  return connect(state => ({
    rma: state.rmaDetail.get("rma")
  }))(Component);
}



// WEBPACK FOOTER //
// ./app/modules/RMAsAndWarranties/decorators/withRma.jsx